import React from "react";
import {
  ClipboardIcon,
  SyringeIcon,
  BloodIcon,
  Computer,
} from "../../../assets/icons/index";
import "./HomeServices.css";

const HomeServices = () => {
  return (
    <section className="home-services">
      <div className="services-title">
        <h3>A Comfortable and Friendly Experience</h3>
        <h2 className="">Here's How We Can Help</h2>
      </div>
      <div className="services-tiles">
        <div className="tile-box">
          <div className="services-tile">
            <ClipboardIcon />
            <h3>
              CLINIC
              <br />
              APPOINTMENTS
            </h3>
          </div>
          <div className="tile-inside">
            <span>
              Our Providers love seeing patients in the office. Our new patient
              appointments are 60 minutes so that we can learn the details and
              complexity of your case. Our providers value and enjoy teaching
              their patients about their autoimmune disease and medication
              options.
            </span>
          </div>
        </div>
        <div className="tile-box">
          <div className="services-tile">
            <SyringeIcon />
            <h3>
              IV INFUSION &
              <br />
              SUB Q INJECTIONS
            </h3>
          </div>
          <div className="tile-inside">
            <span>
              Some medications to treat autoimmune diseases and osteoporosis are
              administered by IV infusion or Injection. At NKY Arthritis, a
              Registered Nurse administers these medications and monitors you
              during your stay. We are happy to administer medication at our
              clinic for other providers and we are the only private infusion
              center in Northern Kentucky with a Medical Provider on-site at all
              times. Please see our Infusion page for more information.
            </span>
          </div>
        </div>
        <div className="tile-box">
          <div className="services-tile">
            <BloodIcon />
            <h3>
              DIAGNOSTIC
              <br />
              ULTRASOUND
            </h3>
          </div>
          <div className="tile-inside">
            <span>
              We utilize an ultrasound machine to provide diagnostic imaging of
              the joints. Xrays often miss early disease as they do not provide
              detail of soft tissue, tendons, and the joint membrane. Our
              imaging is interpreted by a board certified Rheumatologist who is
              also certified in musculoskeletal ultrasound.
            </span>
          </div>
        </div>
        <div className="tile-box">
          <div className="services-tile">
            <Computer />
            <h3>
              FILL YOUR SPECIALIST RHEUMATOLOGY
              <br />
              MEDICATIONS AT NKY ARTHRITIS
            </h3>
          </div>
          <div className="tile-inside">
            <span>
              With our Medial Integrated Dispensing Program you may be able fill
              your Specialty medications (Oral, SubQ, and IV) at our Clinic.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
